module.exports = __webpack_public_path__ + "static/media/anim_selo_copyright_updated.030e82ba.gif";